<table class="logs">
  <tr>
    @if (netzzuordnungIdImportReport().success && !numberOfTransformationWarnings()) {
      <td>
        <span>
          <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley.svg">
        </span>
      </td>
      <td>
        <span data-qa="report-valid">
          Sehr schön, die ausgewählte Datei ist fehlerfrei und kann mit großer Wahrscheinlichkeit importiert werden.
          <p> Dennoch kann es während des eigentlichen Importvorgangs noch zu Fehlern kommen, beispielsweise,
            wenn es zwischenzeitlich Änderungen in der Datenbank gab oder sich Parameter des Leitsystems geändert haben.
          </p>
        </span>
      </td>
    }

    @if (netzzuordnungIdImportReport().success && numberOfTransformationWarnings()) {
      <td>
        <span>
          <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley_meh.svg">
        </span>
      </td>
      <td>
        <span data-qa="report-warning">
          Die ausgewählte Datei kann zwar importiert werden, es gibt allerdings ein oder mehrere Warnungen. Bitte sichten Sie diese sorgfältig, bevor
          Sie den Import starten.
        </span>
      </td>
    }

    @if (!netzzuordnungIdImportReport().success) {
      <td>
        <span>
          <img class="smiley-big" src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
        </span>
      </td>
      <td>
        <span data-qa="report-error">
          Leider müssen wir den Import des Dokuments ablehnen, da entweder das gesamte Dokument oder ein oder mehrere der Netzzuordnung-Ids ungültige oder
          unvollständige Daten enthalten. Gehen Sie bitte anhand der folgenden Liste die Fehler in Ihrem
          CSV-Dokument durch und starten den Import nach der Korrektur erneut. Welche Daten beim Import
          erwartet werden, finden Sie in unserer Ausfüllhilfe.
        </span>
      </td>
    }
  </tr>
</table>

@if (areLogsPresent()) {
  <div data-qa="amount-of-errors">
    <h2 data-qa="error-header">
      <span class="error-count">
        {{ numberOfTransformationErrors() }}
      </span> Fehler gefunden
      @if (numberOfTransformationWarnings()) {
        <span> und <span class="warning-count">
          {{ numberOfTransformationWarnings() }}
        </span> Auffälligkeit{{ numberOfTransformationWarnings() > 1 ? 'en' : '' }}</span>
        } gefunden
      </h2>
    </div>

    <div data-qa="report-details-table">
      @if (isAmountOfErrorItemsToHigh()) {
        <div data-qa="report-AmountOfErrorItemsToHigh">
          <p>Bei über {{ MAX_ITEMS }} Fehlern kann der Bericht nicht angezeigt werden, stattdessen zeigt die
            folgende Tabelle
            die Fehlerkategorie und die Anzahl, wie oft diese in der Datei aufgetreten ist.
          </p>
          @if (numberOfTransformationErrors()) {
            <table class="logs">
              <thead>
                <tr>
                  <th><h3>Fehler-Code</h3></th>
                  <th><h3>Anzahl fehlerhafte Zeilen</h3></th>
                </tr>
              </thead>
              <tbody>
                @for (errorCode of errorCodeCounts() | keyvalue; track errorCode.key) {
                  <tr data-qa="report-error-code-row">
                    <td>{{ errorCode.key | nzIdErrorCodeReadable }}</td>
                    <td>{{ errorCode.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          @if (numberOfTransformationWarnings()) {
            <table class="logs">
              <thead>
                <tr>
                  <th><h3>Warning-Code</h3></th>
                  <th><h3>Anzahl Zeilen mit Warnung</h3></th>
                </tr>
              </thead>
              <tbody>
                @for (warningCode of warningCodeCounts() | keyvalue; track warningCode.key) {
                  <tr data-qa="report-warning-code-row">
                    <td>{{ warningCode.key | nzIdWarningCodeReadable }}</td>
                    <td>{{ warningCode.value }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      } @else {
        <div>
          @for (log of netzzuordnungIdImportReport().log; track $index) {
            <div [attr.data-qa]="(isError(log) ? 'error' : 'warning') + '-detail'">
              <hr>
                <h3>Zeile {{ log.lineNumber + 1 }}</h3>

                <table class="logs">
                  <tr>
                    @if (isError(log)) {
                      <td>
                        <img class="smiley-small"
                          src="/assets/innogy-icons/smileys/innogy_picto_smiley_sad.svg">
                        </td>
                        <td>
                          @if (log.message) {
                            <strong>{{ log.message }}</strong>
                          }
                          {{ log.errorCode | nzIdErrorCodeReadable }}
                        </td>
                      }

                      @if (isWarning(log)) {
                        <td>
                          <img class="smiley-small"
                            src="/assets/innogy-icons/smileys/innogy_picto_smiley_meh.svg">
                          </td>
                          <td>
                            @if (log.message) {
                              <strong>{{ log.message }}</strong>
                            }
                            {{ log.warningCode | nzIdWarningCodeReadable }}
                          </td>
                        }
                      </tr>
                    </table>
                  </div>
                }
              </div>
            }
          </div>
        }
